import React from 'react'
import {
  Box,
  Container,
  Typography,
  Grid,
  Avatar,
  Button,
  useTheme,
  Divider,
  styled,
} from '@mui/material'
import { ArrowForward } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import FacultyData from '../../Assets/JSON/MV.json'
import {
  IMAGE_BASE_PATH_COMMON,
  IMAGE_BASE_PATH_DBRAIMT,
} from '../../Config/Config'

const TitleBox = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  position: 'relative',
  marginBottom: theme.spacing(2),
}))

const PersonItem = ({ person }) => {
  const theme = useTheme()
  const navigate = useNavigate()
  const hasProfile = !!person?.pathurl

  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'background.paper',
        borderRadius: 3,
        border: `1px solid ${theme.palette.divider}`,
        transition: '0.3s',
        height: '100%',
        cursor: hasProfile ? 'pointer' : 'default',
        '&:hover': {
          boxShadow: hasProfile
            ? `0 4px 20px ${theme.palette.action.hover}`
            : 'none',
          transform: hasProfile ? 'translateY(-2px)' : 'none',
        },
      }}
      onClick={() => hasProfile && navigate(`/${person.pathurl}`)}
    >
      <Avatar
        src={
          person?.image
            ? IMAGE_BASE_PATH_DBRAIMT + person.image
            : IMAGE_BASE_PATH_COMMON + 'Placeholder_Image.jpg'
        }
        alt={person?.Name}
        sx={{
          width: 140,
          height: 140,
          mb: 2,
          border: `2px solid ${theme.palette.text.main}`,
        }}
        imgProps={{
          onError: (e) => {
            e.target.src = IMAGE_BASE_PATH_COMMON + 'Placeholder_Image.jpg'
          },
        }}
      />
      <Typography
        variant="subtitle1"
        fontWeight={700}
        textAlign="center"
        sx={{ px: 1, color: theme.palette.text.main }}
      >
        {person.Name}
      </Typography>
      <Typography
        variant="body2"
        fontWeight={500}
        textAlign="center"
        sx={{ color: theme.palette.text.main, px: 1, mt: 0.5 }}
      >
        {person.designation}
      </Typography>
      {hasProfile && (
        <Button
          size="small"
          endIcon={<ArrowForward fontSize="small" />}
          sx={{
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.8rem',
            mt: 2,
            color: theme.palette.text.primary,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          }}
        >
          View Profile
        </Button>
      )}
    </Box>
  )
}

const DepartmentSection = ({ title, data }) => {
  const head = data.find((p) => p.isHead)
  const others = data.filter((p) => !p.isHead)
  const theme = useTheme()

  return (
    <Box>
      <TitleBox>
        <Typography
          variant="h4"
          component="h5"
          sx={{
            color: theme.palette.text.primary,
            fontWeight: 'bold',
            position: 'relative',
            display: 'inline-block',
          }}
        >
          {title}
          <Box
            sx={{
              position: 'absolute',
              width: '70px',
              height: '4px',
              backgroundColor: 'background.secondaryBackground',
              borderRadius: 1,
            }}
          />
        </Typography>
      </TitleBox>

      {head && (
        <Box sx={{ mb: 5 }}>
          <Box display="flex" justifyContent="center">
            <Box maxWidth={350} width="100%">
              <PersonItem person={head} />
            </Box>
          </Box>
        </Box>
      )}

      <Grid container spacing={4} justifyContent="center">
        {others.map((person, idx) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={idx}>
            <PersonItem person={person} />
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

const AccountsAndAdminComponent = () => {
  const accounts = FacultyData?.AccountsData?.Staff || []
  const admin = FacultyData?.AdminData?.Faculty || []

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
      <Box sx={{ px: { xs: 2, sm: 4, md: 6 } }}>
        {/* Admin Section */}
        <DepartmentSection title="Administrative Department" data={admin} />

        {/* Divider */}
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 5 }}>
          <Divider sx={{ width: '60%' }} />
        </Box>

        {/* Accounts Section */}
        <DepartmentSection title="Accounts Department" data={accounts} />
      </Box>
    </Container>
  )
}

export default AccountsAndAdminComponent
